import {CloseButton, Drawer, Loader, Tabs, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconX from "../../../assets/x.svg?react";
import {usePanel} from "./PanelContext";
import {PanelContent} from "./PanelContent";
import classes from "./SliderPanel.module.css";

export const SliderPanel = () => {
    const {items, activeKey, isOpen, closeAll, closePanel, setActivePanel} =
        usePanel();
    const {t} = useTranslation();

    return (
        <Drawer
            opened={isOpen}
            onClose={closeAll}
            position="right"
            size="lg"
            trapFocus={false}
            lockScroll={false}
            withOverlay={false}
            withCloseButton={false}
            transitionProps={{exitDuration: 0}}
            classNames={{
                content: classes.drawerContent,
                body: classes.drawerBody,
            }}
        >
            <div className={classes.toolbar}>
                <CloseButton
                    onClick={closeAll}
                    aria-label={t("Action.ClosePanel", {
                        defaultValue: "Close panel",
                    })}
                />
            </div>

            <Tabs
                value={activeKey}
                onChange={(val) => val && setActivePanel(val)}
                classNames={{tabLabel: classes.tabLabel, root: classes.tabsRoot}}
            >
                <Tabs.List className={classes.tabsList}>
                    {items.map((item) => (
                        <Tabs.Tab
                            key={item.key}
                            value={item.key}
                            rightSection={
                                <span
                                    role="button"
                                    tabIndex={0}
                                    className={classes.tabCloseButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closePanel(item.key);
                                    }}
                                    onKeyDown={(e) => {
                                        if (
                                            e.key === "Enter" ||
                                            e.key === " "
                                        ) {
                                            e.stopPropagation();
                                            closePanel(item.key);
                                        }
                                    }}
                                    aria-label={t("Action.CloseTab", {
                                        defaultValue: "Close tab",
                                    })}
                                >
                                    <IconX width={12} height={12} />
                                </span>
                            }
                        >
                            {item.label}
                        </Tabs.Tab>
                    ))}
                </Tabs.List>

                {items.map((item) => (
                    <Tabs.Panel
                        key={item.key}
                        value={item.key}
                        pt="sm"
                        className={classes.tabsPanel}
                    >
                        {item.status === "loading" && (
                            <>
                                <Loader size="sm" />{" "}
                                {t("Phrase.LoadingModal", {
                                    defaultValue: "Loading...",
                                })}
                            </>
                        )}
                        {item.status === "loaded" && (
                            <PanelContent item={item} />
                        )}
                        {item.status === "error" && (
                            <Text c="red">
                                {item.error ||
                                    t("Word.Error", {defaultValue: "Error"})}
                            </Text>
                        )}
                    </Tabs.Panel>
                ))}
            </Tabs>
        </Drawer>
    );
};
